<style scoped>
  .eb9d-00o1l{
    font-size: 78px;
    color:#19be6b;
    text-align: center;
    line-height: 80px;
  }
  .r31s-99228{
    font-size: 14px;
    color:#464c5b;
  }

</style>
<template>
  <div  style="background-color: #f8f8f8;min-height: 100%;padding:10px;">
    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <div style="text-align: center">
          <Icon type="ios-checkmark-circle-outline" class="eb9d-00o1l"/>
        </div>
        <div style="text-align: center" class="r31s-99228">
          操作已完成，请手动<a @click="back">点击跳转</a>页面
        </div>
      </div>
    </Card>

  </div>
</template>

<script>
  export default {
    methods:{
      back(){
        this.$router.go(-1);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/success.vue